define('v3/Common/Bindings/Badge.binding',['jquery', 'knockout'], function ($, ko) {
	ko.bindingHandlers.badge = {
		init: function (element, valueAccessor, allBindingsAccessor) {
			var badgecontent = ko.utils.unwrapObservable(valueAccessor());

			var badgeExtraClass = ko.unwrap(allBindingsAccessor().badgeExtraClass);
			if (!badgeExtraClass) {
				badgeExtraClass = 'badge-circle';
			}

			if (badgecontent) {
				$(element).addClass('badge ' + badgeExtraClass).attr('data-badge', badgecontent);
			}
		},
		update: function (element, valueAccessor, allBindingsAccessor) {
			var badgecontent = ko.utils.unwrapObservable(valueAccessor());

			var badgeExtraClass = ko.unwrap(allBindingsAccessor().badgeExtraClass);
			if (!badgeExtraClass) {
				badgeExtraClass = 'badge-circle';
			}

			if (badgecontent) {
				$(element).addClass('badge ' + badgeExtraClass).attr('data-badge', badgecontent);
			} else {
				$(element).removeClass('badge ' + badgeExtraClass).removeAttr('data-badge');
			}
		}
	};
});

